module.exports = __webpack_public_path__ + "static/media/urbangoo14.4ff5e53b.webp";